import React from 'react';
import Icon from '../../../components/AppIcon';

const ActiveTrips = ({ trips, currentLanguage }) => {
  const translations = {
    en: {
      title: 'Active Trips',
      noTrips: 'No active trips',
      capacity: 'Capacity',
      departure: 'Departure',
      return: 'Return',
      categories: 'Allowed Categories'
    },
    ko: {
      title: '활성 여행',
      noTrips: '활성 여행이 없습니다',
      capacity: '용량',
      departure: '출발',
      return: '귀국',
      categories: '허용 카테고리'
    }
  };

  const t = translations?.[currentLanguage];

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return currentLanguage === 'en' ? date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
      : date?.toLocaleDateString('ko-KR', { month: 'long', day: 'numeric' });
  };

  const getCategoryLabel = (category) => {
    const labels = {
      en: {
        electronics: 'Electronics',
        fashion: 'Fashion',
        cosmetics: 'Cosmetics',
        food: 'Food',
        books: 'Books',
        toys: 'Toys',
        other: 'Other'
      },
      ko: {
        electronics: '전자제품',
        fashion: '패션',
        cosmetics: '화장품',
        food: '식품',
        books: '도서',
        toys: '장난감',
        other: '기타'
      }
    };
    return labels?.[currentLanguage]?.[category] || category;
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-md overflow-hidden h-full flex flex-col">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Plane" size={20} color="var(--color-primary)" />
          </div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            {t?.title}
          </h2>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        {trips?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Plane" size={48} color="var(--color-muted)" className="mx-auto mb-3" />
            <p className="text-muted-foreground">{t?.noTrips}</p>
          </div>
        ) : (
          <div className="p-4 md:p-6 space-y-4">
            {trips?.map((trip) => (
              <div key={trip?.id} className="p-4 bg-muted/20 rounded-lg border border-border hover:border-primary/50 transition-colors">
                {/* Route */}
                <div className="flex items-center gap-3 mb-3">
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="text-lg font-semibold text-foreground">
                        {trip?.from_country}
                      </span>
                      <Icon name="ArrowRight" size={20} color="var(--color-primary)" />
                      <span className="text-lg font-semibold text-foreground">
                        {trip?.to_country}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Dates */}
                <div className="grid grid-cols-2 gap-3 mb-3">
                  <div className="flex items-center gap-2">
                    <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
                    <div>
                      <div className="text-xs text-muted-foreground">{t?.departure}</div>
                      <div className="text-sm font-medium text-foreground">
                        {formatDate(trip?.departure_date)}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
                    <div>
                      <div className="text-xs text-muted-foreground">{t?.return}</div>
                      <div className="text-sm font-medium text-foreground">
                        {formatDate(trip?.return_date)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Capacity */}
                <div className="flex items-center gap-2 mb-3 p-2 bg-success/10 rounded">
                  <Icon name="Package" size={14} color="var(--color-success)" />
                  <span className="text-sm text-foreground">
                    {t?.capacity}: <span className="font-semibold">{trip?.capacity_kg} kg</span>
                  </span>
                </div>

                {/* Categories */}
                {trip?.allowed_categories?.length > 0 && (
                  <div>
                    <div className="text-xs text-muted-foreground mb-2">{t?.categories}</div>
                    <div className="flex flex-wrap gap-1.5">
                      {trip?.allowed_categories?.map((category, idx) => (
                        <span
                          key={idx}
                          className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full"
                        >
                          {getCategoryLabel(category)}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActiveTrips;